// extracted by mini-css-extract-plugin
export default {"headerRow":"ufkjPuWwdmerOQzv81LE"};